// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

div.src-components-Popup-styles--root--hHsET {
  padding: 10px 15px 15px;
  min-width: 290px;
  max-width: 360px;
  width: 100%;
  margin-left: 15px;
  margin-right: 15px;
}

@media screen and (min-width: 768px) {

div.src-components-Popup-styles--root--hHsET {
    padding: 20px 25px 25px;
}
  }

@media (max-width: 390px) {

div.src-components-Popup-styles--root--hHsET {
    width: calc(100% - 30px);
}
  }

div.src-components-Popup-styles--root--hHsET a,div.src-components-Popup-styles--root--hHsET [data-anchor] {
    color: #6674a6;
    color: var(--greyishBlue);
  }

@media screen and (max-width: 767.98px) {

div.src-components-Popup-styles--root--hHsET footer > button + button {
      margin-top: 15px;
  }
    }

@media screen and (min-width: 768px) {

div.src-components-Popup-styles--root--hHsET footer > button + button {
      margin-left: 20px;
  }
    }

@media screen and (max-width: 767.98px) {

div.src-components-Popup-styles--root--hHsET button {
      font-size: 13px;
  }

      div.src-components-Popup-styles--root--hHsET button > span {
        height: 55px !important;
        line-height: 55px !important;
      }
    }

.src-components-Popup-styles--title--nsqzS {
  font-weight: 500;
  font-size: 17px;
  line-height: 1.18;
  margin-bottom: 15px;
}

@media screen and (min-width: 768px) {

.src-components-Popup-styles--title--nsqzS {
    font-size: 20px;
    line-height: 1.25;
}
  }

.src-components-Popup-styles--content--Omc7S {
  width: 100%;
  line-height: 23px;
  font-size: 14px;
}

.src-components-Popup-styles--content--Omc7S p {
    margin: 15px 0;
    line-height: 25px;
  }

.src-components-Popup-styles--content--Omc7S b,.src-components-Popup-styles--content--Omc7S strong {
    font-weight: 500;
  }

@media screen and (min-width: 768px) {

.src-components-Popup-styles--content--Omc7S {
    font-size: 13px;
    line-height: 22px;
}

    .src-components-Popup-styles--content--Omc7S p {
      margin: 10px 0;
      line-height: 20px;
    }
  }

.src-components-Popup-styles--locked--jELIN {
  overflow: hidden;
}

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W {
  padding: 20px 15px 25px;
}

@media screen and (min-width: 768px) {

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W {
    padding: 20px 25px 25px;
}
  }

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W .src-components-Popup-styles--title--nsqzS {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 15px 0 0;
  margin-bottom: 15px;
}

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W .src-components-Popup-styles--title--nsqzS h2 {
    font-size: 17px;
    font-weight: 500;
    line-height: 25px;
    text-align: center;
    margin: 20px 0 10px;
  }

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W .src-components-Popup-styles--title--nsqzS p {
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: normal;
    text-align: center;
  }

@media screen and (min-width: 768px) {

.src-components-Popup-styles--root--hHsET.src-components-Popup-styles--promo--wUD2W .src-components-Popup-styles--title--nsqzS p {
      font-size: 13px;
  }
    }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/Popup/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AAmCpB;;AAjCE;;AARF;IASI,uBAAuB;AAgC3B;EA/BE;;AAEA;;AAZF;IAaI,wBAAwB;AA4B5B;EA3BE;;AAEA;IAEE,cAAyB;IAAzB,yBAAyB;EAC3B;;AAGE;;AADF;MAEI,gBAAgB;EAMpB;IALE;;AAEA;;AALF;MAMI,iBAAiB;EAErB;IADE;;AAIA;;AADF;MAEI,eAAe;EAOnB;;MALI;QACE,uBAAuB;QACvB,4BAA4B;MAC9B;IACF;;AAIJ;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AAMrB;;AAJE;;AANF;IAOI,eAAe;IACf,iBAAiB;AAErB;EADE;;AAGF;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AAqBjB;;AAnBE;IACE,cAAc;IACd,iBAAiB;EACnB;;AAEA;IAEE,gBAAgB;EAClB;;AAEA;;AAfF;IAgBI,eAAe;IACf,iBAAiB;AAOrB;;IALI;MACE,cAAc;MACd,iBAAiB;IACnB;EACF;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AAKzB;;AAHE;;AAHF;IAII,uBAAuB;AAE3B;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AAsBrB;;AApBE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;AAEA;IACE,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;EAKpB;;AAHE;;AARF;MASI,eAAe;EAEnB;IADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\ndiv.root {\n  padding: 10px 15px 15px;\n  min-width: 290px;\n  max-width: 360px;\n  width: 100%;\n  margin-left: 15px;\n  margin-right: 15px;\n\n  @media (--desktop) {\n    padding: 20px 25px 25px;\n  }\n\n  @media (max-width: 390px) {\n    width: calc(100% - 30px);\n  }\n\n  & a,\n  & [data-anchor] {\n    color: var(--greyishBlue);\n  }\n\n  & footer > button + button {\n    @media (--mobile) {\n      margin-top: 15px;\n    }\n\n    @media (--desktop) {\n      margin-left: 20px;\n    }\n  }\n\n  & button {\n    @media (--mobile) {\n      font-size: 13px;\n\n      & > span {\n        height: 55px !important;\n        line-height: 55px !important;\n      }\n    }\n  }\n}\n\n.title {\n  font-weight: 500;\n  font-size: 17px;\n  line-height: 1.18;\n  margin-bottom: 15px;\n\n  @media (--desktop) {\n    font-size: 20px;\n    line-height: 1.25;\n  }\n}\n\n.content {\n  width: 100%;\n  line-height: 23px;\n  font-size: 14px;\n\n  & p {\n    margin: 15px 0;\n    line-height: 25px;\n  }\n\n  & b,\n  & strong {\n    font-weight: 500;\n  }\n\n  @media (--desktop) {\n    font-size: 13px;\n    line-height: 22px;\n\n    & p {\n      margin: 10px 0;\n      line-height: 20px;\n    }\n  }\n}\n\n.locked {\n  overflow: hidden;\n}\n\n.root.promo {\n  padding: 20px 15px 25px;\n\n  @media (--desktop) {\n    padding: 20px 25px 25px;\n  }\n}\n\n.root.promo .title {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 15px 0 0;\n  margin-bottom: 15px;\n\n  & h2 {\n    font-size: 17px;\n    font-weight: 500;\n    line-height: 25px;\n    text-align: center;\n    margin: 20px 0 10px;\n  }\n\n  & p {\n    margin: 0;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 20px;\n    letter-spacing: normal;\n    text-align: center;\n\n    @media (--desktop) {\n      font-size: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-Popup-styles--root--hHsET`,
	"title": `src-components-Popup-styles--title--nsqzS`,
	"content": `src-components-Popup-styles--content--Omc7S`,
	"locked": `src-components-Popup-styles--locked--jELIN`,
	"promo": `src-components-Popup-styles--promo--wUD2W`
};
module.exports = ___CSS_LOADER_EXPORT___;
